import React, {useState}  from "react";
import Swal from 'sweetalert2'
import img1 from '../../assets/aboutImage.png'
import img2 from '../../assets/aboutImage__.png'
import Team from "../team/Team";
import './aboutUs.css'


const AboutUs = () => {
    const [show, setShow] = useState(false)
    const abouts = [
        {
            name: 'Our Goal',
            desc: 'Kpoikpoimingi limited is a Nigerian Company founded in May 18,2017 with identification number 1414488 based on B13, Lousiana Garden City Dakwo District,Abuja Fct.'
        },
        {
            name:'Our Vision',
            desc: 'Kpoikpoimingi limited is a Nigerian Company founded in May 18,2017 with identification number 1414488 based on B13, Lousiana Garden City Dakwo District,Abuja Fct.'
        },
        {
            name: 'Our Mission',
            desc: 'Kpoikpoimingi limited is a Nigerian Company founded in May 18,2017 with identification number 1414488 based on B13, Lousiana Garden City Dakwo District,Abuja Fct.'
        }
    ]
  return (
    <section id="about" className='bg-secondary'>
        <div className='container md:pr-[57px] w-full md:pl-[61px]'>
            <h1 className='w-[98px] md:w-[200px] text mt-[47px] md:mt-[107px] md:mb-[118px]'>About Us</h1>

            <div className='items-center justify-center gap-x-10 hidden  md:flex md:flex-col xl:flex-row'>
                <div className='xl:basis-[60%]'>
                    <div>
                        <p className='mb-[19px] w-[660px] h-[120px] text-[16px] font-normal leading-[24px] tracking-[0.005em]'>
                            Kpoikpoimingi limited is a Nigerian Company founded in May 18,2017 with identification number 1414488 based on B13, Lousiana Garden City Dakwo District,Abuja Fct.Kpoikpoimingi limited is a company built on trust and transparency ,our core focus is building a healthy and ethical standard in fostering financial literacy in our world today.We are commited to providing exceptional customer service through technology and innovation
                        </p>
                        <p className='mb-[77px] w-[660px] h-[120px] text-[16px] font-normal leading-[24px] tracking-[0.005em]'>
                            Kpoikpoimingi limited is a Nigerian Company founded in May 18,2017 with identification number 1414488 based on B13, Lousiana Garden City Dakwo District,Abuja Fct.Kpoikpoimingi limited is a company built on trust and transparency ,our core focus is building a healthy and ethical standard in fostering financial literacy in our world today.We are commited to providing exceptional customer service through technology and innovation
                        </p>
                    </div>
                    <div>
                        <div>
                        <h2 className='mb-[26px] text-[16px] tracking-[0.005em] text-primary not-italic leading-[24px]'>Our Goal</h2>
                        <p className='mb-[29px] w-[660px] h-[120px] text-[16px] font-normal leading-[24px] tracking-[0.005em]'>
                            Kpoikpoimingi limited is a Nigerian Company founded in May 18,2017 with identification number 1414488 based on B13, Lousiana Garden City Dakwo District,Abuja Fct.Kpoikpoimingi limited is a company built on trust and transparency ,our core focus is building a healthy and ethical standard in fostering financial literacy in our world today.We are commited to providing exceptional customer service through technology and innovation
                        </p>
                        </div>
                        <div>
                        <h2 className='mb-[26px] text-[16px] text-primary tracking-[0.005em] not-italic leading-[24px]'>Our Mission</h2>
                        <p className='w-[660px] h-[120px] text-[16px] font-normal leading-[24px] tracking-[0.005em]'>
                            Kpoikpoimingi limited is a Nigerian Company founded in May 18,2017 with identification number 1414488 based on B13, Lousiana Garden City Dakwo District,Abuja Fct.Kpoikpoimingi limited is a company built on trust and transparency ,our core focus is building a healthy and ethical standard in fostering financial literacy in our world today.We are commited to providing exceptional customer service through technology and innovation
                        </p>
                        </div>
                    </div>
                        <button onClick={() => setShow(true)} className={`${!show ?'block btn mt-[78px]' : 'hidden btn mt-[78px]'}  `}>Read more</button>
                </div>
                <div className='xl:basis-[40%] w-full mt-[160px]  md:hidden lg:block'>
                    <div className='relative ml-[50px]  left-[50%] top-[30%] translate-x-[-50%] translate-y-[-20%]'>
                        <img className='relative ' src={img1} alt="/" />
                        <img className='absolute left-[-84px] hover:left-[0] hover:top-0 top-[128px] transition-all duration-150 ease-in' src={img2} alt="/" />
                    </div>
                </div>
            </div>



            {/* for mobile device */}
            <div className='md:hidden px-[20px] w-full mx-auto h-[160px] mt-[47px] '>
                <p className='font-normal not-italic text-[14px] leading-[20px] tracking-[0.0025em] '>Kpoikpoimingi limited is a Nigerian Company founded in May 18,2017 with identification number 1414488 based on B13, Lousiana Garden City Dakwo District,Abuja Fct.Kpoikpoimingi limited is a company built on trust and transparency ,our core focus is building a healthy and ethical standard in fostering financial literacy in our world today.We are commited to providing exceptional customer service through technology and innovation</p>
            </div>
            <div className='Mobilemission w-full md:hidden flex space-x-[18px] justify-center h-[100px] px-[20px] mt-[44px] md:mt-[34px]'>
                {abouts.map((about, i) => (
                    <div onClick={() => Swal.fire
                    ({title: `<p>${about.desc}</p>`,
                    confirmButtonColor: '#3C8C30',
                    })} className='w-[102px] h-[40px] flex items-center justify-center hover:bg-light transition duration-200 ease-in whitespace-nowrap  py-[10px] px-[20px] border border-solid border-primary rounded-[4px] cursor-pointer' key={i}>
                        <h3 className='text-primary '>{about.name}</h3>
                    </div>
                ))}

            </div>
            <div className="md:hidden flex justify-center">
                <button onClick={() => setShow(true)} className={!show ?'block btn mt-[78px]' : 'hidden btn mt-[78px]'}>Read more</button>
            </div>
            <div className={!show ?'block relative  mt-[77px] left-5 lg:left-0 lg:mt-0 mb-[140px] lg:mb-0 lg:hidden w-full px-[20px]' : 'hidden relative left-5 lg:left-0 mt-[78px] lg:mt-0 mb-[140px] lg:mb-0 lg:hidden w-full px-[20px]'}>
                    {/* for mobile */}
                    <div className='w-full flex flex-col items-center lg:block md:hidden relative lg:ml-[50px] left-[45%]  lg:left-[50%] top-[50%] lg:top-[30%] translate-x-[-50%] lg:translate-x-[-50%] translate-y-[-10%] lg:translate-y-[-20%]'>
                        <img className='relative w-[255px] h-[233px] ' src={img1} alt="/" />
                        <img className='absolute w-[255px] h-[233px] translate-y-6 -translate-x-6 hover:translate-y-0 hover:-translate-x-0 transition duration-200 ease-linear' src={img2} alt="/" />
                    </div>

                    {/* for tablet display */}
                    <div className=' w-full mt-[160px] hidden md:block'>
                    <div className='relative ml-[50px] left-[50%] top-[30%] translate-x-[-50%] translate-y-[-20%]'>
                        <img className='relative ' src={img1} alt="/" />
                        <img className='absolute left-[-84px] hover:left-[0] hover:top-0 top-[128px] transition-all duration-150 ease-in' src={img2} alt="/" />
                    </div>
                </div>
                </div>
        </div>
        {show && (<Team />)}

{/* 
        <div className='w-full flex flex-col items-center border border-green-800 lg:block md:hidden relative lg:ml-[50px] left-[45%]  lg:left-[50%] top-[50%] lg:top-[30%] translate-x-[-50%] lg:translate-x-[-50%] translate-y-[-10%] lg:translate-y-[-20%]'>
                        <img className='relative w-[255px] h-[233px] ' src={img1} alt="/" />
                        <img className='absolute w-[255px] h-[233px]  left-[20px] hover:left-[59.7px] lg:left-[-84px] lg:hover:left-[0] lg:hover:top-0 top-[71px] hover:top-0 lg:top-[128px] transition-all duration-150 ease-in' src={img2} alt="/" />
                    </div> */}

    </section>

        
  )
}

export default AboutUs